import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export interface AppLayoutContext {
  search: string;
}

const AppLayout = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="flex h-screen overflow-hidden bg-ns-app">
      <Sidebar />
      <main className="flex-1 min-w-0 p-4 sm:p-6 flex flex-col overflow-y-auto bg-ns-app">
        <Topbar search={search} onSearchChange={setSearch} />
        <div className="flex-1 min-w-0">
          <Outlet context={{ search } satisfies AppLayoutContext} />
        </div>
        <p className="text-xs text-gray-400 text-right mt-6">
          @2026 <strong className="text-gray-900">NativState</strong> Pulse
        </p>
      </main>
    </div>
  );
};

export default AppLayout;
